import React from "react";
import StoreTables from "components/Tables/Store/StoreTables";

const ListStore = () => {
  return (
    <div>

      <StoreTables />
    </div>
  );
};

export default ListStore;
